
<template>
    <footer>
        <div class="container">
            <div class="footer_inner">
                <div class="footer_part">
                    <img v-if="brandWord === 'Citroen'" src='../../src/assets/iown-logo-citroen.jpg' alt="IOWN Citroen logo" class="footer_logo" />
                    <img v-if="brandWord === 'Peugeot'" src='../../src/assets/iown-logo1.png' alt="IOWN Peugeot logo" class="footer_logo" />
                    <img v-if="brandWord === 'Opel'" src='../../src/assets/iown-logo1.png' alt="IOWN Opel logo" class="footer_logo" />

                    <p class="footer_text">
                        Responsible lending criteria, fees and charges apply. iOWN is provided by Heartland Bank Limited.
                    </p>
                </div>

                <div class="footer_part">
                    <ul class="footer_nav">
                        <li>
                            <a href="https://www.heartland.co.nz/privacy-statement" target="_blank">Privacy policy</a>
                        </li>
                        <li>
                            <a href="https://www.heartland.co.nz/website-terms-of-use" target="_blank">Website terms of use</a>
                        </li>
                        <li>
                            <a href="https://www.heartland.co.nz/unforeseen-hardship" target="_blank">Unforeseen hardship</a>
                        </li>
                        <li>
                            <a href="https://www.heartland.co.nz/car-loans/rates-fees-terms" target="_blank">Rates, fees and terms</a>
                        </li>
                        <li>
                            <a href="https://www.heartland.co.nz/compliments-and-complaints" target="_blank">Compliments and complaints</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
  name: 'FooterComponent',
  props: {
    brandWord: {
      type: String,
      default: 'Peugeot'
    }
  }
}

</script>

<style scoped>
</style>
